/**
 * Created by Administrador on 20/11/2017.
 */
(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('generalDiscountCtrl', generalDiscountCtrl)
        .controller('newEditGeneralDiscountCtrl', newEditGeneralDiscountCtrl)
        .controller('deleteGeneralDiscountCtrl', deleteGeneralDiscountCtrl);

    generalDiscountCtrl.$inject = ['linkService', 'generalDiscounts'];

    newEditGeneralDiscountCtrl.$inject = ['generalDiscountService', 'linkService', 'generalDiscount','action'];

    deleteGeneralDiscountCtrl.$inject = ['generalDiscount', 'generalDiscountService', '$uibModalInstance','linkService'];

    function generalDiscountCtrl(linkService, generalDiscounts){
        var vm = this;

        vm.generalDiscounts = (generalDiscounts.data._embedded) ? generalDiscounts.data._embedded.generalDiscounts : [];
        vm.linkService = linkService;
    }

    function newEditGeneralDiscountCtrl(generalDiscountService, linkService, generalDiscount, action){
        var vm = this;
        vm.linkService = linkService;
        vm.generalDiscount = {};

        if(action == 'edit'){
            vm.generalDiscount.lang = generalDiscount.data.lang;
            vm.generalDiscount.priority = generalDiscount.data.priority;
            vm.generalDiscount.generalDiscountId = vm.linkService.getLinkId(generalDiscount.data._links.self.href);
        }

        vm.save = function(isValid, generalDiscount){
            if (isValid) {
                generalDiscount.active = true;
                generalDiscount.baseTariff = false;
                if(action == "new"){
                    generalDiscountService.saveGeneralDiscount(generalDiscount);
                }else{
                    generalDiscountService.updateGeneralDiscount(vm.generalDiscount.generalDiscountId, vm.generalDiscount)
                }
            }
        }
    }

    function deleteGeneralDiscountCtrl(generalDiscount, generalDiscountService, $uibModalInstance,linkService){
        var vm = this;
        vm.generalDiscount = generalDiscount.data;

        vm.delete = function(){
            generalDiscountService.deleteGeneralDiscount(linkService.getLinkId(generalDiscount.data._links.self.href))
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
